import { Api } from '../axios-config';

// Empresa desativada no painel de controle — checado logo após o login e ao
// reabrir uma sessão salva (ver AuthContext.tsx), igual ao FrontSIAC.
const verificarAtiva = async (): Promise<boolean> => {
  try {
    // silencioso: o interceptor do PDV desloga em 404 — se o servidor ainda
    // não tiver a rota, só não bloqueia (ver ErrorInterceptor).
    const silencioso: Record<string, unknown> = { silencioso: true };
    const { data } = await Api.get('/empresa/status', { ...silencioso });
    return data?.ativa !== false;
  } catch {
    // Falha na consulta (inclusive sem internet — PDV offline) não pode
    // travar o acesso de ninguém.
    return true;
  }
};

export const EmpresaStatusService = {
  verificarAtiva,
};
